import DannyGuthrieSrc from './images/danny-guthrie.png';
import RichDadSrc from './images/rich-dad.png';
import MattMersinoSrc from './images/matt-mersino.png';
import NickBockenfeldSrc from './images/nick-bockenfeld.png';
import richDadLogoSrc from './images/rich-dad-logo.png';
import oneTextLogoSrc from './images/one-text-logo.png';
import amplusLogoSrc from './images/amplus-logo.png';
import ballisticLogoSrc from './images/ballistic-logo.png';
import { Influencer } from './CustomerQualificationFlow';

export const websiteVisitorsOptions = [
  { value: '0-10000', label: '0 - 10,000 visitors' },
  { value: '10001-20000', label: '10,001 - 20,000 visitors' },
  { value: '20001-50000', label: '20,001 - 50,000 visitors' },
  { value: '50001-99999', label: '50,000+ visitors' },
];

export const adSpendOptions = [
  { value: '0-10000', label: '$0 - 10,000' },
  { value: '10001-20000', label: '$10,001 - 20,000' },
  { value: '20001-50000', label: '$20,001 - 50,000' },
  { value: '50001-99999', label: '$50,000+' },
];

export const isUSAgency = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export const agencyPartnership = [
  { value: 'refer', label: 'I refer my clients' },
  {
    value: 'highlevel_whitelabel',
    label: 'I whitelabel solutions to my clients via HighLevel',
  },
  {
    value: 'other_whitelabel',
    label: 'I whitelabel solutions to my clients via another platform',
  },
];

export const agencyWebsiteVisitorsOptions = [
  { value: '0-20000', label: '0-20k' },
  { value: '21000-100000', label: '21k-100k' },
  { value: '100000-200000', label: '100k+' },
];

export const agencyServicesOptions = [
  { value: 'email_marketing', label: 'Email Marketing' },
  { value: 'meta_ads', label: 'Meta Ads' },
  { value: 'email_and_ads_marketing', label: 'Both Email and Meta Ads' },
  { value: 'none', label: "We don't offer Email or Meta Ads" },
];

export const influencers = {
  1: [
    {
      photo: RichDadSrc,
      name: 'Rich Dad',
      companyLogo: richDadLogoSrc,
      quote: ` “Customers.ai performs much better than our old tools. We
            struggled at first with 14-15% email open rates and it took a lot
            of effort to get to 32%. With Customers.ai we're seeing 65-85%
            open rates… and it saves me a ton of time.”`,
    },
    {
      photo: DannyGuthrieSrc,
      name: 'Danny Guthrie',
      role: 'Sales Team Lead',
      companyLogo: oneTextLogoSrc,
      quote: `“We used Customers.ai to improve lead attribution and fill the
            sales funnel. In just 30 days, we were able to capture 1400 new
            contacts and add over $70,000 in MRR to the sales pipeline.”`,
    },
  ] as Influencer[],
  2: [
    {
      photo: NickBockenfeldSrc,
      name: 'Nick Bockenfeld',
      role: 'Agency Manager',
      companyLogo: amplusLogoSrc,
      quote: `“Customers.ai is able to easily extract lead information in a way 
      I did not know possible. It is easy to use, 
      has incredible email open rates and is just so easy to get on the site and use.”`,
    },
    {
      photo: MattMersinoSrc,
      name: 'Matt Mersino',
      role: 'Co-founder',
      companyLogo: ballisticLogoSrc,
      quote: `“Getting into the level of granular control that Customers.ai offers 
      and the filtering abilities and the ability to control the solution 
      as it relates to the users — not just the user experience 
      but the users' behavior on your site so you can really dial in 
      how you want to use the solution.”`,
    },
  ] as Influencer[],
};

export const getQualificationFlowDescription = (isAgency: boolean) => [
  {
    1: {
      title: 'Book a call to start your free trial',
      description: `Get a personalized walkthrough and consultation to see how 
        Customers.ai can drive your business growth`,
    },
    2: isAgency
      ? {
          title: 'Tell us about your agency',
          description: `Qualified agencies get a personalized demo and learn about 
            how we partner with agencies to increase client performance and grow retainers.`,
        }
      : {
          title: 'Tell us about your business',
          description: `Get a personalized walkthrough and consultation to see how 
            Customers.ai can drive your business growth`,
        },
  },
];
